import { TransactionDirection } from "@bitwarden/web-vault/app/models/enum/transactionDirection";
import {
  BalanceByAccounts,
  BalanceByAccountsSymbols,
} from "@bitwarden/web-vault/app/models/types/balanceGroupingTypes";
import { SplitClassificationType } from "@bitwarden/web-vault/app/models/types/split-classification-type";
import { SplitCategory } from "@bitwarden/web-vault/app/models/data/shared/split-category/split-category";
import { TransactionView } from "@bitwarden/web-vault/app/models/view/transaction/transaction.view";
import { createTransactionView } from "@bitwarden/web-vault/app/models/view/transaction/transaction.utils";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";

// TODO: @mmeshel - maybe we can consolidate these last functions into a util filedif

/**
 * TransactionBalances - This class will house all the helper functions that
 * are used to manipulate the current transaction objects into the required
 * objects for the web workers that calculate the balances needed
 */
export class TransactionBalanceHelpers {
  /**
   * createStartingTransactionsFromBalance - Given a list of starting balances for accounts and symbols, create the
   * corresponding starting transactions
   */
  async createStartingTransactionsFromBalance(
    startDate: Date,
    startingBalances: BalanceByAccountsSymbols,
    userStoreService: UserStoreService,
    description: string,
  ): Promise<Array<TransactionView>> {
    // TODO: @mmeshel - we need to find the default classifications and categories once the system supports them again
    const defaultSplitClassification: SplitClassificationType[] = [];
    const defaultSplitCategory: SplitCategory[] = [];

    const transactions = [];
    for (const accountID in startingBalances) {
      const accountView: AccountView = userStoreService.accounts
        .accountViews()
        .find((account) => account.id === accountID);
      const symbolBalances = startingBalances[accountID];
      for (const symbol in symbolBalances) {
        const symbolAmount = symbolBalances[symbol];
        const mockTransaction = createTransactionView(
          accountID,
          accountView.institutionLink.institutionId,
          symbolAmount,
          symbol,
          startDate,
          description,
          [], // allocations (TODO: use account default allocation when they are implemented)
          null,
          true,
        );
        transactions.push(mockTransaction);
      }
    }
    return transactions;
  }

  addTransactionToBalanceByAccounts(
    balanceByAccounts: BalanceByAccounts,
    transaction: TransactionView,
  ) {
    const account = transaction.accountLink.id;
    const symbol = transaction.quantity.actualQuantity.symbol;

    if (!balanceByAccounts?.[account]) {
      balanceByAccounts[account] = {};
    }
    let transactionAmount = transaction.quantity.actualQuantity.amount;
    if (transaction.direction === TransactionDirection.Out && transactionAmount > 0) {
      transactionAmount = -1 * transactionAmount;
    }
    if (balanceByAccounts?.[account]?.[symbol]) {
      balanceByAccounts[account][symbol] += transactionAmount;
    } else {
      balanceByAccounts[account][symbol] = transactionAmount;
    }
  }

  /**
   * sumAccountBalances - sums the account balances for the given currency
   * @param balanceByAccounts
   * @param currency
   */
  sumAccountBalances(balanceByAccounts: BalanceByAccounts, currency: string) {
    let total = 0;
    for (const account in balanceByAccounts) {
      if (balanceByAccounts[account]?.[currency]) {
        total += balanceByAccounts[account][currency];
      }
    }
    return total;
  }
}
